<template>
  <v-container fluid id="geo">
    <v-row no-gutters>
      <v-container style="color: white">
        <v-row no-gutters justify="center" class="text-center">
          <v-col cols="12" xl="4" lg="6" md="8" sm="10">
            <v-col style="width: 100%;"><h2 class="display-2 font-weight-black">{{$t('geo.title')}}</h2></v-col>
            <v-col style="width: 100%;"><h3 class="headline font-weight-regular">{{$t('geo.subtitle1')}}</h3></v-col>
            <v-col style="width: 100%; margin-top: -1.2rem"><h3 class="headline font-weight-regular">
              {{$t('geo.subtitle2')}}</h3></v-col>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-row justify="center" style="margin-top: 100px">
      <v-col
        cols="10"
        xl="4"
        lg="6"
        md="6"
        sm="8"
        class="bordered display-1 font-weight-black font-italic"
        style="color: white"
        v-html="$t('geo.slogan')"
      >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Geo'
  }
</script>

<style scoped>
  #geo {
    background: url('../assets/world.png') no-repeat center top;
    background-size: contain;
  }

  .bordered {
    min-height: 150px;
    padding: 40px;
    text-align: center;

    background-color: transparent;
    background-image: linear-gradient(to right, #9A9A9A 30px, transparent 30px), linear-gradient(to right, #9A9A9A 30px, transparent 30px), linear-gradient(to bottom, #9A9A9A 30px, transparent 30px), linear-gradient(to bottom, #9A9A9A 30px, transparent 30px);
    background-size: 100% 50px, 100% 50px, 50px 100%, 50px 100%;
    background-position: -15px 0%, -15px 100%, 0% -15px, 100% -15px;
    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  }
</style>
